<template>
  <div class="h-datagrid">
    <div class="h-datagrid-title" v-if="hasTitle">
      <h4><span>{{ title }}</span></h4>
    </div>
    <div class="h-datagrid-toolbar datagrid-toolbar" v-if="hasToolBar">
      <div class="pull-left">
        <slot name="toolbarLeft"></slot>
      </div>
      <div v-if="dropList" class="pull-right">
        <slot name="toolbarRight"></slot>
        <h-dropdown trigger="click" placement="bottom-end" @on-visible-change="settingHandle" v-if="showSettingBtn">
          <h-button type="ghost" icon="t-b-setting" class="setting-btn">
            <h-icon :name="settingIcon"></h-icon>
          </h-button>
          <div class="dropdown-list" slot="list" :style="widthStyle">
            <div v-for="(it, idx) in showColumns" :key="idx" class="dropdown-item">
              <h-checkbox :value="it.key || it.type" :true-value="it.key || it.type" :false-value="it.key ||  it.type" :disabled="it.disabled" @on-change="checkHandle">
                <span class="ml">{{ it.title }}</span>
              </h-checkbox>
            </div>
          </div>
        </h-dropdown>
      </div>
    </div>
    <div class="otp-datagrid">
      <div class="h-table-box" :style="{height: gridHeight + 'px'}">
        <h-tree-gird v-if="type === 'tree'" :data="rowData" :columns="columns" :border="border" :size="size" :stripe="stripe" :show-header="showHeader" :width="width" :height="gridHeight" :loading="isLoading" :disabled-hover="disabledHover" :highlight-row="highlightRow" :rowSelect="rowSelect" :is-checkbox="isCheckbox" :ref="selfAdaptTable"></h-tree-gird>
        <h-edit-gird v-else-if="type === 'edit'" :data="rowData" :columns="columns" :stripe="stripe" :border="border" :show-header="showHeader" :width="width" :height="gridHeight" :canDrag="canDrag" :size="size" :loading="isLoading" :disabled-hover="disabledHover" :highlight-row="highlightRow" :rowSelect="rowSelect" :no-data-text="onDataText" :show-edit-input="showEditInput" :option="option" :tree-option="treeOption" :cascader-option="cascaderOption" :multi-level="multiLevel" :no-filtered-data-text="noFilteredDataText" @on-row-click="onRowClick" @on-row-dblclick="onRowDbClick" @on-editinput-change="onEditInputChange" @on-money-change="onMoneyChange" @on-current-change="onCurrentChange" @on-select="onSelect" @on-select-cancel="onSelectCancel" @on-select-all="onSelectAll" @on-editselect-change="editSelectChange" @on-selection-change="onSelectChange" @on-sort-change="onSortChange" @on-expand="onExpand" :ref="selfAdaptTable"></h-edit-gird>
        <h-table v-else :data="rowData" :columns="columns" :border="border" :size="size" :stripe="stripe" :show-header="showHeader" :width="width" :height="gridHeight" :canDrag="canDrag" :loading="isLoading" :disabled-hover="disabledHover" :highlight-row="highlightRow" :rowSelect="rowSelect" :row-class-name="rowClassName" :no-data-text="onDataText" :no-filtered-data-text="noFilteredDataText" @on-row-click="onRowClick" @on-row-dblclick="onRowDbClick" @on-current-change="onCurrentChange" @on-select="onSelect" @on-select-cancel="onSelectCancel" @on-select-all="onSelectAll" @on-selection-change="onSelectChange" @on-sort-change="onSortChange" @on-expand="onExpand" :ref="selfAdaptTable" :showTitle="showTitle"></h-table>
      </div>
      <div class="page-box-r" style="margin-top:8px;">
        <h-page :current="pageInfo.pageNo" :total="total" :page-size="pageSize" :placement="placement" :simple="simple" :show-total="showTotal" :show-elevator="showElevator" :show-sizer="showSizer" :pageSizeOpts="pageSizeOpts" :class-name="className" :styles="styles" size="small" @on-change="dataChange" @on-page-size-change="pageSizeChange" v-if="hasPage" ref="gridPage">
        </h-page>
      </div>
    </div>
  </div>
</template>
<script>
import cloneDeep from 'clone-deep'
// import mockjs from '@frame/api/mock.js'
import { mapGetters } from 'vuex'
export default {
  name: 'HDataGrid',
  data () {
    return {
      rowData: [],
      total: 0,
      pageInfo: {
        pageNo: 1,
        pageSize: 10
      },
      hasToolBar: true,
      isLoading: false, // 仅在url中生效，非URL在外部配置
      settingIcon: 'unfold',
      gridHeight: 50,
      extData: '',
      bindParams: {}
    }
  },
  props: {
    title: String, // 表格列表头部信息,
    type: {
      type: String,
      default: 'normalTable'
    },
    gridData: Object, // 数据信息，包含表格信息rows及分页信息total[可以通过property自定义rows字段]
    columns: Array,
    border: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'small'
    },
    stripe: {
      type: Boolean,
      default: true
    },
    dropList: {
      type: Boolean,
      default: true
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    width: [Number, String],
    height: [Number, String],
    canDrag: {
      type: Boolean,
      default: true
    },
    disabledHover: {
      type: Boolean,
      default: false
    },
    highlightRow: {
      type: Boolean,
      default: false
    },
    rowSelect: {
      type: Boolean,
      default: false
    },
    isCheckbox: {
      type: Boolean,
      default: false
    },
    rowClassName: Function,
    onDataText: String,
    showEditInput: {
      // eidt grid owner
      type: Boolean,
      default: false
    },
    noFilteredDataText: String,
    onRowClick: {
      type: Function,
      default () {
        return ''
      }
    },
    onRowDbClick: {
      type: Function,
      default () {
        return ''
      }
    },
    onEditInputChange: {
      type: Function,
      default () {
        return ''
      }
    },
    onMoneyChange: {
      type: Function,
      default () {
        return ''
      }
    },
    onCurrentChange: {
      type: Function,
      default () {
        return ''
      }
    },
    onSelect: {
      type: Function,
      default () {
        return ''
      }
    },
    onSelectCancel: {
      type: Function,
      default () {
        return ''
      }
    },
    onSelectAll: {
      type: Function,
      default () {
        return ''
      }
    },
    editSelectChange: {
      type: Function,
      default () {
        return ''
      }
    },
    onSelectChange: {
      type: Function,
      default () {
        return ''
      }
    },
    onSortChange: {
      type: Function,
      default () {
        return ''
      }
    },
    onExpand: {
      type: Function,
      default () {
        return ''
      }
    },
    dataTransfer: {
      type: Function,
      default () {
        return ''
      }
    },
    current: Number,
    pageSize: Number,
    placement: {
      type: String,
      default: 'top'
    },
    pageSizeOpts: Array,
    simple: Boolean,
    showTotal: {
      type: Boolean,
      default: true
    },
    showElevator: {
      type: Boolean,
      default: true
    },
    showSizer: {
      type: Boolean,
      default: true
    },
    className: String,
    styles: Object,
    hasPage: {
      // 是否显示分页
      type: Boolean,
      default: false
    },
    getDataFunc: {
      // 分页获取data函数，该参数必须配gridData || 无分页情况,直接返回rows,同时配置get-data事件
      type: Boolean,
      default: false
    },
    url: String, // 参考2.0 通过url请求数据
    bindForm: Object,
    autoLoad: {
      // 设置URL时是否自动加载数据，默认true
      type: Boolean,
      default: true
    },
    loading: {
      // 非url时使用
      type: Boolean,
      default: true
    },
    property: {
      type: Object,
      default () {
        // 自定义返回字段
        return {
          totalItem: 'totalItem',
          rows: 'rows',
          pageNo: 'pageNo',
          pageSize: 'pageSize',
          responseType: 'data',
          extAttr: 'extAttr'
        }
      }
    },
    selfAdaptTable: {
      type: String
    },
    showSettingBtn: {
      type: Boolean,
      default: true
    },
    dropListWidth: {
      type: String,
      default: '120px'
    },
    extHeight: {
      type: Number,
      default: 0
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    current (val) {
      this.pageInfo.pageNo = val
    },
    pageSize (val) {
      this.pageInfo.pageSize = val
    },
    gridData: {
      handler (nv, ov) {
        let r = this.property.rows
        if (nv && nv[r] && nv[r].length > 0) {
          this.rowData = nv[r]
        } else {
          this.rowData = []
        }
        if (this.hasPage) {
          let t = this.property.totalItem
          if (nv && nv[t]) {
            this.total = nv[t]
          } else {
            this.total = 0
          }
        }
      },
      deep: true
    },
    loading (val) {
      this.isLoading = val
    },
    bindForm: {
      handler (nv, ov) {
        this.bindParams = nv || {}
      },
      deep: true,
      immediate: true
    },
    isLoadFooter (nv) {
      if (nv) {
        this.selfAdaption()
      }
    }
  },
  computed: {
    ...mapGetters(['isLoadFooter']),
    showColumns () {
      // 数据过滤
      let nvs = this.columns.filter(it => it.key || it.type)
      let target = cloneDeep(nvs)
      // 数据转换
      return target.map(it => {
        if (it.type === 'selection') {
          it.title = '选择框'
        }
        return it
      })
    },
    hasTitle () {
      return this.title && this.title !== ''
    },
    widthStyle () {
      return { width: `${this.dropListWidth}` }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.isLoadFooter && !window.isElectron) return
      this.selfAdaption()
    })
  },
  created () {
    // 数据初始化
    if (this.height) {
      this.gridHeight = this.height
    }
    let l = this.$slots.toolbarLeft
    let r = this.$slots.toolbarRight
    if (!l && !r) {
      this.hasToolBar = false
    }
    // 自动加载数据
    if (this.autoLoad) {
      return this.getDataList()
    }
    // 手工加载数据
    if (this.gridData) {
      this.setGridData()
    }
  },
  methods: {
    queryPageData () {
      const me = this
      // 设置加载状态
      me.isLoading = me.loading
      // 设置查询参数
      let query = me.pageInfo
      Object.assign(query, me.bindParams)
      me.$request
        .jsonRequest(me.url, query)
        .then(r => {
          if (r) {
            // 数据特殊处理
            let transfer = me.dataTransfer(r)
            r = transfer || r
            // 重置加载状态
            me.isLoading = false
            const { totalItem, rows, responseType, extAttr } = me.property
            let ds = r[responseType]
            me.extData = r.data[extAttr]
            if (rows === '') {
              if (ds instanceof Array) {
                me.rowData = ds
                me.total = ds.length
              } else if (ds instanceof Object) {
                me.rowData = []
                me.rowData.push(ds)
                me.total = 1
              }
            } else {
              me.rowData =
                ds[totalItem] && ds[totalItem] > 0 && ds[rows] ? ds[rows] : []
              me.total =
                ds[totalItem] && ds[totalItem] > 0 && ds[rows]
                  ? ds[totalItem]
                  : 0
            }
            me.$nextTick(function () {
              me.$emit('data-load-success', me.rowData, me.total)
            })
          }
        })
        .catch(e => {
          console.error(e)
          me.isLoading = false
          me.$toast(
            'error',
            e.errorInfo || e.error_info || e.error_msg || '数据加载失败'
          )
        })
    },
    queryListData () {
      const me = this
      let query = me.bindParams
      me.$request
        .jsonRequest(me.url, query)
        .then(r => {
          if (r) {
            // 数据特殊处理
            let transfer = me.dataTransfer(r)
            r = transfer || r
            me.isLoading = false
            let ds = r[me.property.responseType],
              rw = me.property.rows
            if (ds[rw] && ds[rw].length > 0) {
              me.rowData = ds[rw]
            } else if (ds && ds.length > 0) {
              me.rowData = ds
            } else if (ds && ds[rw] && ds[rw].length > 0) {
              me.rowData = ds[rw]
            } else {
              me.rowData = []
            }
            me.$nextTick(function () {
              me.$emit('data-load-success', me.rowData, ds)
            })
          }
        })
        .catch(e => {
          console.error(e)
          me.isLoading = false
          me.$toast(
            'error',
            e.errorInfo || e.error_info || e.error_msg || '数据加载失败'
          )
        })
    },
    getDataListByUrl () {
      this.isLoading = this.loading
      if (this.hasPage) {
        this.queryPageData()
      } else {
        this.queryListData()
      }
    },
    setGridData () {
      // 赋值
      let r = this.property.rows
      if (this.gridData[r]) {
        this.rowData = this.gridData[r]
      }
      if (this.hasPage) {
        let t = this.property.totalItem
        if (this.gridData[t]) {
          this.total = this.gridData[t]
        }
      }
    },
    getDataList () {
      if (this.url) {
        // 远程加载数据
        this.getDataListByUrl()
      } else if (this.getDataFunc) {
        if (this.hasPage) {
          this.$emit('get-data', this.pageInfo)
        } else {
          this.$emit('get-data')
        }
      } else {
        // 本地加载数据
        this.setGridData()
      }
    },
    // 点击上一页
    dataChange (i) {
      this.pageInfo.pageNo = i
      this.getDataList()
      this.$emit('on-page-change-url', this.pageInfo)
    },
    // 页码改变
    pageSizeChange (i) {
      this.pageInfo.pageSize = i
      this.pageInfo.pageNo = 1
      this.getDataList()
      this.$emit('on-page-change-url', this.pageInfo)
    },
    // 反选某行的选中状态，仅多选
    toggleTableSelect (index) {
      let gd = this.$refs[this.selfAdaptTable]
      if (gd && gd.selectType) {
        gd.toggleSelect(index)
      } else {
        this.$toast('info', '仅支持表格多选')
      }
    },
    // 表格导出功能
    exportCsv (params) {
      /* {
          filename:  '' // 文件名
          columns: []// 导出表格列
          data: [] // 导出表格数据
          noHeader: false //是否导出表格头
        } */
      let gd = this.$refs[this.selfAdaptTable]
      gd && gd.exportCsv(params)
    },
    // 计算表格高度
    calculateHeight (outerHeight) {
      // let appEl = this.getEle('page-main')
      let appEl = this.getEle('page-main')
      let noticeEl = this.getEle('h-notice-bar')
      let tabsBarEl = this.getEle('h-tabs-bar')
      let noticeH = noticeEl.length === 0 ? 0 : noticeEl.clientHeight
      let tabsBarH = tabsBarEl.length === 0 ? 0 : tabsBarEl[0].clientHeight
      let appOffsetTop = appEl.length === 0 ? 0 : appEl[0].clientHeight
      let searchEl = this.getEle('h-search-box')
      let titleEl = this.getEle('h-datagrid-title')
      let toolbarEl = this.getEle('h-datagrid-toolbar')
      let pageEl = this.getEle('page-box-r')
      let tabIndex = this.property.index
      if (tabIndex === undefined) {
        tabIndex = 0
      }
      let objects = {
        search:
          typeof searchEl[tabIndex] === 'undefined'
            ? 'undefined'
            : searchEl[tabIndex],
        titleBar: typeof titleEl[0] === 'undefined' ? 'undefined' : titleEl[0],
        toolbar:
          typeof toolbarEl[0] === 'undefined' ? 'undefined' : toolbarEl[0],
        paging: typeof pageEl[0] === 'undefined' ? 'undefined' : pageEl[0]
      }
      if (tabsBarH > 0) {
        tabsBarH += 52
      }
      let extralHeight = 0,
        themeDiffHeight = 36
      Object.keys(objects).forEach(function (key, index) {
        if (objects[key] !== 'undefined') {
          extralHeight += objects[key].clientHeight
        }
      })
      appOffsetTop = outerHeight || appOffsetTop
      // console.log(appOffsetTop + '-' + extralHeight + '-' + noticeH + '-' + tabsBarH + '-' + themeDiffHeight)
      return appOffsetTop - extralHeight - noticeH - tabsBarH - themeDiffHeight
    },
    // 表格自适应
    selfAdaption (outerHeight) {
      let gd = this.$refs[this.selfAdaptTable]
      if (gd) {
        if (this.height) {
          this.gridHeight = this.height + this.extHeight
          return false
        }
        this.$nextTick(() => {
          // 计算表格高度
          let selfHeight = this.calculateHeight(outerHeight)
          // if (selfHeight > 50) {
          this.gridHeight = selfHeight + this.extHeight
          // }
        })
      }
    },
    settingHandle (visible) {
      this.settingIcon = visible ? 'packup' : 'unfold'
    },
    columnHandle (val) {
      // 处理表格列表的显示与隐藏
      this.columns.forEach(el => {
        let key = el.key ? el.key : el.type
        if (key === val) {
          el.hiddenCol = !el.hiddenCol
        }
      })
    },
    checkHandle (val) {
      // 触发父组件的on-change事件
      this.columnHandle(val)
      this.$emit('on-change', val)
    },
    getEle (cls) {
      return document.getElementsByClassName(cls)
    },
    getRowData () {
      return this.rowData
    },
    getChangeData () {
      let gd = this.$refs[this.selfAdaptTable]
      return gd && gd.getChangeData()
    },
    handleModifyData (idx, data) {
      let gd = this.$refs[this.selfAdaptTable]
      return gd && gd.handleModifyData(idx, data)
    },
    selectAll (flag) {
      let gd = this.$refs[this.selfAdaptTable]
      return gd && gd.selectAll(flag)
    },
    clearGridData () {
      this.total = 0
      this.rowData.splice(0, this.rowData.length)
    },
    getExtData () {
      return this.extData
    }
  }
}
</script>
<style lang="scss" scoped>
.h-datagrid-title {
  height: 32px;
  padding: 5px 18px 4px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  color: #333;
  background: #fff;
  border-bottom: 0;
  padding-bottom: 8px;
  padding-top: 0;
  position: relative;
  padding-left: 12px;
}
.h-datagrid-title h4 {
  margin: 0;
  font-weight: 700;
  line-height: 22px;
}
.lightblue .h-datagrid-title h4 span:before {
  content: '';
  height: 16px;
  display: block;
  position: absolute;
  top: 3px;
  left: 0;
  width: 4px;
  background-color: #029afd;
}
.black .h-datagrid-title h4 span:before {
  content: '';
  height: 16px;
  display: block;
  position: absolute;
  top: 3px;
  left: 0;
  width: 4px;
  background-color: #029afd;
}
.h-datagrid-toolbar {
  padding: 0 0 8px 0;
  min-height: 40px;
  border-width: 1px 1px 0;
}
.h-datagrid-toolbar {
  .pull-right {
    display: flex;
    flex-direction: row;
    .setting-btn {
      height: 28px;
      line-height: 15px;
      // margin-top: 8px;
    }
    .dropdown-list {
      max-width: 120px;
      max-height: 200px;
      overflow: auto;
      .dropdown-item {
        .h-checkbox-wrapper {
          white-space: nowrap;
          cursor: pointer;
        }
      }
    }
    .ml {
      margin-left: 4px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.lightblue .h-datagrid-toolbar .pull-left {
  font-size: 0;
}
.black .h-datagrid-toolbar .pull-left {
  font-size: 0;
}
.lightblue .h-datagrid-toolbar .pull-left .h-btn {
  margin-right: 8px;
  // margin-top: 8px;
}
.black .h-datagrid-toolbar .pull-left .h-btn {
  margin-right: 8px;
  margin-top: 8px;
}
.h-datagrid-toolbar .h-btn {
  padding: 6px 15px;
}
.h-datagrid-toolbar .h-btn > .h-icon + span,
.h-datagrid-toolbar .h-btn > span + .h-icon {
  font-size: 14px;
  color: #666;
  margin-left: 0;
}
.h-datagrid-toolbar .h-btn .iconfont {
  font-size: 16px;
  color: #000;
}
.h-datagrid-toolbar .h-btn.h-btn-disable > .h-icon + span,
.h-datagrid-toolbar .h-btn.h-btn-disable > span + .h-icon,
.h-datagrid-toolbar .h-btn.h-btn-disable .iconfont {
  color: inherit;
}
.h-datagrid .h-table-small td {
  height: 30px;
}
.h-datagrid .h-select-item {
  padding: 3px 16px;
}
.h-datagrid .h-page {
  margin: 5px;
}
.h-datagrid .h-page .h-page-prev,
.h-datagrid .h-page .h-page-next,
.h-datagrid .h-page .h-page-item-jump-prev,
.h-datagrid .h-page .h-page-item-jump-next,
.h-datagrid .h-page .h-page-item,
.h-datagrid .h-page .h-page-options-elevator input {
  height: 26px;
  line-height: 24px;
  min-width: 24px;
}
.h-datagrid .h-page .h-select-single .h-select-selection,
.h-datagrid .h-page .h-select-single .h-select-selection .h-select-placeholder,
.h-datagrid
  .h-page
  .h-select-single
  .h-select-selection
  .h-select-selected-value {
  height: 28px;
  line-height: 26px;
}
</style>
